import { IFloorPlanModel } from '@api/models';
import { getAllFloorPlans } from '@api/services/site-walk.service';
import useDataQuery from '@hooks/use-data-query';
import { produce } from 'immer';

interface IFloorPlanListOptions {
    clientId: string;
    projectId: string;
}

const useFloorPlanListData = (props: IFloorPlanListOptions) => {
    const { clientId, projectId } = props;

    const floorPlanListQuery = useDataQuery(['floor-plans', clientId, projectId], () =>
        getAllFloorPlans(clientId, projectId)
    );

    const handleDelete = (floorPlan: IFloorPlanModel) => {
        floorPlanListQuery.setData((prev) => {
            if (!prev) return;

            const index = prev.findIndex((c) => c._id === floorPlan._id);
            return produce(prev, (draft) => {
                draft.splice(index, 1);
                return draft;
            });
        });
    };

    return {
        floorPlans: floorPlanListQuery.data,
        isLoading: floorPlanListQuery.isLoading,
        handleDelete,
    };
};

export default useFloorPlanListData;
